module.exports = __webpack_public_path__ + "img/Rectangle Copy 14@1232x.77bbcca1.png";